import { useState } from "react";
import { toast } from "sonner";
import { supervisorApi } from "@/lib/SupervisorApi";
import { Modal, Field, inputCls } from "./SupervisorPrimitives";

/**
 * Force-reset the Super Manager PIN of a tenant — used when the
 * customer has forgotten their PIN and can't login at all.
 */
export default function ResetPinDialog({ tenant, onClose, onDone }) {
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pin.length < 4) return;
    setBusy(true);
    try {
      await supervisorApi.resetPin(tenant.tenant_code, pin);
      toast.success(`Νέο PIN για ${tenant.tenant_code}: ${pin}`);
      onDone();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Σφάλμα");
    } finally { setBusy(false); }
  };

  return (
    <Modal title={`Reset PIN — ${tenant.business_name}`} onClose={onClose}>
      <form onSubmit={submit}>
        <p className="text-sm text-zinc-400 mb-4">
          Θέτει νέο PIN στον Super Manager του πελάτη <span className="font-mono text-amber-400">{tenant.tenant_code}</span>.
          <br />Ο πελάτης θα συνδέεται με αυτό το νέο PIN.
        </p>
        <Field label="Νέο PIN (4-12 χαρακτήρες)">
          <input
            required minLength={4} maxLength={12}
            value={pin}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, ""))}
            placeholder="••••"
            className={inputCls + " font-mono text-2xl tracking-widest text-center"}
            data-testid="reset-pin-input"
          />
        </Field>
        <div className="flex gap-2 justify-end pt-4 border-t border-zinc-800 -mx-6 px-6">
          <button type="button" onClick={onClose} className="h-10 px-4 rounded-lg bg-zinc-800 hover:bg-zinc-700 text-zinc-200 text-sm font-bold">Άκυρο</button>
          <button type="submit" disabled={busy || pin.length < 4} className="h-10 px-5 rounded-lg bg-amber-600 hover:bg-amber-500 text-white font-bold text-sm disabled:opacity-40" data-testid="reset-pin-submit">
            {busy ? "..." : "Αλλαγή PIN"}
          </button>
        </div>
      </form>
    </Modal>
  );
}
